import {
  hasRoleForSrStaff,
  hasRolePartner,
} from 'common/userRoles';

const browserNames = ['WebKit', 'Chrome WebView'];
export const androidOsName = 'Android';
export const iphoneOsName = 'iOS';

export function isChromeBrowser(userAgent) {
  return (userAgent.browserName || '').includes('Chrome');
}

export function getNativeAppLink(userAgent) {
  if (userAgent.osName === iphoneOsName) {
    return 'https://itunes.apple.com/us/app/sunroom-rentals/id1445221096?mt=8';
  }

  if (userAgent.osName === androidOsName) {
    return 'https://play.google.com/store/apps/details?id=com.mobile.sunroomrentals';
  }

  return null;
}

export function isUserAgentIphoneApp(userAgent = {}) {
  return (
    browserNames.includes(userAgent.browserName)
    && userAgent.osName === iphoneOsName
  );
}

export function isUserAgentAndroidApp(userAgent = {}) {
  return (
    browserNames.includes(userAgent.browserName)
    && userAgent.osName === androidOsName
  );
}

// List of pathnames where the native app banner should be hidden.
const nativeAppBannerPathnamesBlacklist = [
  /^\/$/,
  /^\/start$/,
  /^\/get-started$/,
  /^\/signup-agent$/,
  /^\/signup-buyer-agent$/,
  /^\/login$/,
  /^\/invite$/,
  /^\/start\/switch-to-apartments$/,
  /^\/invite-roommate$/,
  /^\/search\/?(\w+)?$/,
  /^\/application\//,
  /^\/locatortours\//,
  /^\/partner\//,
  /^\/connect-bank\//,
  /^\/security-deposit\//,
];

export const shouldShowPartnerRedirectionBanner = ({ location, currentUser }) => {
  return (
    hasRolePartner(currentUser.roles)
    && !hasRoleForSrStaff(currentUser.roles)
    && !location.pathname.includes('partner/')
  );
};

export function shouldShowNativeAppBanner({
  userAgent,
  location,
  currentUser,
}) {
  return (
    !isUserAgentMobileApp(userAgent)
    && getNativeAppLink(userAgent)
    && !nativeAppBannerPathnamesBlacklist.some(((expR) => expR.test(location.pathname)))
    && !location.pathname.includes('verify-phone')
    && !currentUser.settings.nativeBannerAppClosed
    && !shouldShowPartnerRedirectionBanner({ location, currentUser })
  );
}

export default function isUserAgentMobileApp(userAgent) {
  return isUserAgentIphoneApp(userAgent) || isUserAgentAndroidApp(userAgent);
}

export function isUserAgentMobile(userAgent = {}) {
  return (
    userAgent.isMobile
    || userAgent.osName === iphoneOsName
    || userAgent.osName === androidOsName
    || isUserAgentMobileApp(userAgent)
  );
}
